import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Input,
  Select,
  Typography,
  Divider,
  Row,
  DatePicker,
  Radio,
  Tag,
  Slider,
} from "antd";
import Upload from "../../common/Upload";
import styles from "./index.module.css";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { validationRules } from "../../common/Utils";
import {
  getFields,
  saveStep,
  updateStep,
  getTotalDependents,
  uploadFile,
  enableFlag,
} from "../../../store/policy";
import moment from "moment";
import { convertNumberToWord } from "../../common/Utils";
import {
  Users,
  ChevronUp,
  ChevronDown,
  AlertTriangle,
  ArrowLeft,
  ArrowRight,
  Loader,
  Heart,
} from "lucide-react";
import CustomInput from "../../common/CustomInput";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import {
  checkEmailExists,
  resetEmailCacheForStep,
  setCurrentStep,
} from "../../../store/medicalAssessmentSlice";

const { Option } = Select;

const radioStyle = {
  backgroundColor: "#f0fdfa",
  padding: "10px 15px",
  borderRadius: "10px",
  border: "1px solid #028D86",
};

function Step2({ setCurrent, current }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState({});
  const [dependants, setDependents] = useState();
  const existingValues = sessionStorage.getItem("values");
  const [fileLoading, setFileLoading] = useState([]);
  const [dependentCollapsed, setDependentCollapsed] = useState([]);
  const [sortedFields, setSortedFields] = useState([]);
  const [commentBoxes, setCommentBoxes] = useState({
    question1: false,
    question2: false,
    question3: false,
    question4: false,
  });
  const coverageCountry = localStorage.getItem("coverageCountry")
    ? localStorage.getItem("coverageCountry")
    : "";
  let initial = true;

  const { emailCheckStatus } = useSelector((state) => state.medicalAssessment);

  const { steps, fields, totalDependents, fileUploading } = useSelector(
    (state) => state.policySlice,
  );
  const stepId = steps?.find((s) => s?.step_number === current)?.id;

  useEffect(() => {
    if (stepId) {
      dispatch(setCurrentStep(stepId));
      dispatch(resetEmailCacheForStep(stepId));
    }
  }, [stepId, dispatch]);

  const onFinish = async () => {
    const values = form.getFieldsValue();

    const emailFields = Object.entries(values).filter(([key, value]) => {
      return (key.includes("email") || key.includes("mail")) && value;
    });

    for (const [fieldName, value] of emailFields) {
      const result = await dispatch(
        checkEmailExists({
          email: value,
          stepId: stepId,
        }),
      );

      if (result.payload?.exists) {
        return;
      }
    }

    form
      .validateFields()
      .then(() => {
        const formData = new Object();
        Object.keys(values).forEach((key) => {
          if (key.includes("upload_id")) {
            const index = key.split("_")[key.split("_").length - 1];
            formData[key] = fileList[parseInt(index)];
          } else if (key.includes("dob")) {
            formData[key] = moment(new Date(values[key])).format("YYYY-MM-DD");
          } else {
            formData[key] = values[key];
          }
        });
        const mappedArray = Object.keys(formData)?.map((key, i) => {
          const field = fields?.find(
            (field) =>
              field.field_name ===
                key
                  .split("_")
                  .slice(0, key.split("_").length - 1)
                  .join("_") || field.field_name === key,
          );
          if (field) {
            return {
              field_id: field.id,
              key: key,
              value: formData[key],
            };
          }
        });
        if (
          !form.isFieldsTouched() &&
          existingValues &&
          JSON.parse(existingValues).find(
            (step) =>
              step.step_id ===
              steps.find((s) => s?.step_number === current)?.id,
          )
        ) {
          setCurrent(3);
        } else if (
          existingValues &&
          JSON.parse(existingValues)?.find(
            (step) =>
              step.step_id ===
              steps?.find((s) => s?.step_number === current)?.id,
          )
        ) {
          dispatch(
            updateStep({
              userId: JSON.parse(sessionStorage.getItem("user"))?.userId,
              stepId: steps?.find((s) => s?.step_number === current)?.id,
              parameters: mappedArray,
            }),
          );
          localStorage.removeItem("lastStep");
        } else {
          dispatch(
            saveStep({
              source: steps?.find((s) => s?.step_number === current)
                ?.step_source,
              user_id: JSON.parse(sessionStorage.getItem("user"))?.userId,
              step_id: steps?.find((s) => s?.step_number === current)?.id,
              parameters: mappedArray,
            }),
          );
        }
      })
      .then(() => setCurrent(3))
      .catch((err) => console.log(err));
    dispatch(enableFlag());
  };

  useEffect(() => {
    if (
      steps &&
      steps?.find((s) => s?.step_number === current) &&
      steps?.find((s) => s?.step_number === current).form_id &&
      steps?.find((s) => s?.step_number === current).id
    ) {
      dispatch(
        getFields({
          formId: steps?.find((s) => s?.step_number === current).form_id,
          stepId: steps?.find((s) => s?.step_number === current).id,
        }),
      ).then((res) => {
        const localFields = res?.payload &&
          Array.isArray(res?.payload) && [...res?.payload];
        setSortedFields(
          localFields?.sort((a, b) => a?.field_sequence - b?.field_sequence),
        );
      });
    }
  }, [steps]);

  useEffect(() => {
    if (
      existingValues &&
      JSON.parse(existingValues)?.find(
        (step) =>
          step.step_id === steps?.find((s) => s?.step_number === current)?.id,
      ) &&
      initial
    ) {
      initial = false;
      const values = JSON.parse(existingValues)?.find(
        (step) =>
          step.step_id === steps?.find((s) => s?.step_number === current)?.id,
      ).parameters;
      const obj = new Object();
      const existingList = { ...fileList };
      for (let key of values) {
        if (key.key.includes("dob") && key.value) {
          obj[key.key] = moment(key.value, "YYYY-MM-DD");
        } else if (key.key.includes("upload_id") && key.value) {
          obj[key.key] = key.value;

          existingList[key.key.split("_").pop()] = key.value;
          setFileList(existingList);
        } else {
          obj[key.key] = key.value;
        }
      }
      form.setFieldsValue(obj);
    }
  }, [steps]);

  useEffect(() => {
    dispatch(getTotalDependents()).then((res) => {
      if (res?.payload?.result?.dependent_count >= 0) {
        setDependents(
          res?.payload?.result?.dependent_count &&
            parseInt(res?.payload?.result?.dependent_count),
        );
        setFileLoading(
          new Array(parseInt(res?.payload?.result?.dependent_count)).fill(
            false,
          ),
        );
        setDependentCollapsed(
          new Array(parseInt(res?.payload?.result?.dependent_count) + 1).fill(
            false,
          ),
        );
      }
    });
  }, [dispatch]);

  const handleChange = async (i, { file }) => {
    if (file.status === "removed") {
      const existingList = { ...fileList };
      if (existingList[i + 1]) {
        delete existingList[i + 1];
        setFileList(existingList);
      }
      return;
    } else {
      const fileLoaders = [...fileLoading];
      fileLoaders[i] = true;
      setFileLoading(fileLoaders);
      const formData = new FormData();
      formData.append("file", file);
      dispatch(uploadFile(formData))
        .then((res) => {
          form.setFieldsValue({
            signature_date: moment(),
            signature_upload: res?.payload?.result,
          });
          setFileList({
            ...fileList,
            [i + 1]: {
              ...res?.payload?.result,
              name: res?.payload?.result?.file_name,
            },
          });
          fileLoaders[i] = false;
          setFileLoading(fileLoaders);
        })
        .catch((err) => console.log(err));
    }
  };

  const collapseDependent = (i) => {
    const existingArray = [...dependentCollapsed];
    existingArray[i] = !existingArray[i];
    setDependentCollapsed(existingArray);
  };

  const getValues = () => {
    const a = Object.keys(form.getFieldsValue()).find((prop) =>
      prop.startsWith("relationship"),
    );

    return a ? (form.getFieldsValue()[a] === "Spouse" ? true : false) : false;
  };

  const checkMedicalQues = (value, ques) => {
    const boxes = { ...commentBoxes };
    boxes[ques] = value == 1 ? true : false;
    setCommentBoxes(boxes);
  };

  return (
    <div className={styles.stepWrapper}>
      <Form form={form} layout="vertical">
        {/* Dependents Card */}
        {dependants > 0 && (
          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <div className={styles.cardIcon}>
                <Users size={22} />
              </div>
              <div>
                <h3 className={styles.cardTitle}>Dependents Information</h3>
                <span className={styles.cardDesc}>
                  Provide details for each dependent
                </span>
              </div>
            </div>
            <div className={styles.cardBody}>
              <div className={styles.formGrid}>
                {new Array(parseInt(dependants)).fill(true)?.map((dep, i) => {
                  return (
                    sortedFields &&
                    sortedFields.length > 0 &&
                    sortedFields
                      ?.slice(
                        0,
                        localStorage.getItem("coverageCountry") === "Kenya"
                          ? 8
                          : 6,
                      )
                      ?.map((field, index) => {
                        if (field?.main_heading === "Dependent") {
                          return (
                            <React.Fragment key={`dep-head-${i}-${index}`}>
                              <div className={styles.sectionHeader}>
                                <span className={styles.sectionTitle}>
                                  {`${convertNumberToWord(i + 1)} Dependent`}
                                </span>
                                <button
                                  type="button"
                                  className={styles.collapseBtn}
                                  onClick={collapseDependent.bind(null, i)}
                                >
                                  {!dependentCollapsed[i] ? (
                                    <>Collapse <ChevronUp size={14} /></>
                                  ) : (
                                    <>Expand <ChevronDown size={14} /></>
                                  )}
                                </button>
                              </div>
                              {!dependentCollapsed[i] && (
                                <Form.Item
                                  className={
                                    field?.type === "file" ? styles.fileUpload : styles.formItem
                                  }
                                  key={index}
                                  label={<span className={styles.fieldLabel}>{field?.label}</span>}
                                  id={field?.id}
                                  name={`${field?.field_name}_${i + 1}`}
                                  rules={validationRules(
                                    field?.validation,
                                    field?.label,
                                    field?.type,
                                  )}
                                >
                                  {field?.type === "text" ? (
                                    <Input
                                      allowClear
                                      className={styles.fieldInput}
                                      placeholder={field?.label}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </Form.Item>
                              )}
                              {i + 1 < dependants && dependentCollapsed[i] && (
                                <div className={styles.sectionDivider} />
                              )}
                            </React.Fragment>
                          );
                        }
                        if (field && !dependentCollapsed[i]) {
                          return (
                            <React.Fragment key={`dep-field-${i}-${index}`}>
                              <Form.Item
                                className={
                                  field?.type === "file" ? styles.fileUpload : styles.formItem
                                }
                                key={index}
                                label={<span className={styles.fieldLabel}>{field?.label}</span>}
                                id={field?.id}
                                name={`${field?.field_name}_${i + 1}`}
                                rules={validationRules(
                                  field?.validation,
                                  field?.label,
                                  field?.type,
                                )}
                                style={{
                                  gridColumn: field?.type === "date" && "span 2",
                                }}
                              >
                                {field?.type === "text" ? (
                                  <Input
                                    allowClear
                                    className={styles.fieldInput}
                                    placeholder={field?.label}
                                  />
                                ) : field?.type === "number" ? (
                                  <CustomInput
                                    placeholder={field?.label}
                                    units={field.unit}
                                    style={{
                                      width: "100%",
                                      height: "40px",
                                      paddingLeft: "8px",
                                    }}
                                    type={"number"}
                                  />
                                ) : field?.type === "file" ? (
                                  <>
                                    <Upload
                                      fileList={
                                        fileList[i + 1] ? [fileList[i + 1]] : []
                                      }
                                      beforeUpload={() => false}
                                      onChange={handleChange.bind(null, i)}
                                      onRemove={() => setFileList([])}
                                      width="100%"
                                    />
                                    {fileLoading[i] ? <Loader size={16} className={styles.spinner} /> : ""}
                                  </>
                                ) : field?.type === "date" ? (
                                  <DatePicker
                                    allowClear
                                    className={styles.fieldDatePicker}
                                    format={"YYYY-MM-DD"}
                                    maxDate={
                                      getValues() && dayjs().subtract(18, "year")
                                    }
                                    disabledDate={(current) => {
                                      return (
                                        current && current > moment().endOf("day")
                                      );
                                    }}
                                  />
                                ) : field?.type === "dropdown" ? (
                                  <Select
                                    allowClear
                                    placeholder={field?.label}
                                    options={field?.dropdowns
                                      ?.filter((r) =>
                                        r?.regions?.find(
                                          (r) => r === coverageCountry,
                                        ),
                                      )?.[0]
                                      ?.values?.map((opt) => {
                                        return {
                                          label: opt?.name,
                                          value: opt?.value,
                                        };
                                      })}
                                    className={styles.fieldSelect}
                                    onChange={() => getValues()}
                                  />
                                ) : (
                                  ""
                                )}
                              </Form.Item>
                              {i + 1 < dependants &&
                                sortedFields?.[index + 1]?.main_heading && (
                                  <div className={styles.sectionDivider} />
                                )}
                            </React.Fragment>
                          );
                        }
                      })
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {/* Medical History Card */}
        <div className={styles.card} style={{ marginTop: dependants > 0 ? 20 : 0 }}>
          <div className={styles.cardHeader}>
            <div className={styles.cardIcon}>
              <Heart size={22} />
            </div>
            <div>
              <h3 className={styles.cardTitle}>Medical History</h3>
              <span className={styles.cardDesc}>
                Please answer the following medical questions
              </span>
            </div>
          </div>
          <div className={styles.cardBody}>
            {sortedFields.length > 0 &&
              sortedFields
                ?.slice(
                  localStorage.getItem("coverageCountry") === "Kenya" ? 8 : 6,
                )
                ?.map((field, index) => {
                  if (field?.main_heading === "Medical History") {
                    return (
                      <React.Fragment key={`med-${index}`}>
                        <div className={styles.sectionHeader}>
                          <span className={styles.sectionTitle}>
                            {field?.main_heading}
                          </span>
                          <button
                            type="button"
                            className={styles.collapseBtn}
                            onClick={collapseDependent.bind(
                              null,
                              dependentCollapsed.length - 1,
                            )}
                          >
                            {!dependentCollapsed[2] ? (
                              <>Collapse <ChevronUp size={14} /></>
                            ) : (
                              <>Expand <ChevronDown size={14} /></>
                            )}
                          </button>
                        </div>
                        {!dependentCollapsed[dependentCollapsed.length - 1] &&
                          field?.alert_message && (
                            <div className={styles.alertBanner}>
                              <AlertTriangle size={16} />
                              <span>{field?.alert_message}</span>
                            </div>
                          )}
                        {!dependentCollapsed[dependentCollapsed.length - 1] &&
                          field?.information && (
                            <p className={styles.infoText}>{field?.information}</p>
                          )}
                        {!dependentCollapsed[dependentCollapsed.length - 1] && (
                          <Form.Item
                            className={styles.formItem}
                            key={index}
                            label={<span className={styles.fieldLabel}>{field?.label}</span>}
                            id={field?.id}
                            name={field?.field_name}
                            rules={validationRules(
                              field?.validation,
                              field?.label,
                              field?.type,
                            )}
                          >
                            {field?.type === "text" ? (
                              <Input
                                allowClear
                                className={styles.fieldInput}
                                placeholder={field?.label}
                              />
                            ) : field?.type === "radio" ? (
                              <>
                                <Radio.Group
                                  onChange={(e) =>
                                    checkMedicalQues(
                                      e.target.value,
                                      field?.field_name,
                                    )
                                  }
                                  options={
                                    field?.values
                                      ? field?.values?.map((field) => {
                                          return {
                                            label: field?.name,
                                            value: field?.value,
                                            style: radioStyle,
                                          };
                                        })
                                      : []
                                  }
                                />
                                {commentBoxes?.[field?.field_name] && (
                                  <Input.TextArea
                                    placeholder="Please specify"
                                    className={styles.textArea}
                                  />
                                )}
                              </>
                            ) : (
                              ""
                            )}
                          </Form.Item>
                        )}
                        {!dependentCollapsed[dependentCollapsed.length - 1] && (
                          <div className={styles.sectionDivider} />
                        )}
                      </React.Fragment>
                    );
                  }
                  if (
                    field &&
                    !dependentCollapsed[dependentCollapsed.length - 1]
                  ) {
                    return (
                      <React.Fragment key={`med-field-${index}`}>
                        {field?.heading && (
                          <div className={styles.subSectionHeading}>{field?.heading}</div>
                        )}

                        <Form.Item
                          className={styles.formItem}
                          key={index}
                          label={<span className={styles.fieldLabel}>{field?.label}</span>}
                          id={field?.id}
                          name={field?.field_name}
                          rules={validationRules(
                            field?.validation,
                            field?.label,
                            field?.type,
                          )}
                        >
                          {field?.type === "text" ? (
                            <Input
                              allowClear
                              className={styles.fieldInput}
                              placeholder={field?.label}
                            />
                          ) : field?.type === "number" ? (
                            <div className={styles.sliderRow}>
                              {field?.validation?.min && (
                                <span className={styles.sliderLabel}>
                                  {field?.label.includes("hours")
                                    ? `${field?.validation?.min} hrs`
                                    : field?.validation?.min}
                                </span>
                              )}
                              <Slider
                                className={styles.customSlider}
                                min={field?.validation?.min}
                                max={field?.validation?.max}
                              />
                              {field?.validation?.max && (
                                <span className={styles.sliderLabel}>
                                  {field?.label.includes("hours")
                                    ? `${field?.validation?.max} hrs`
                                    : field?.validation?.max}
                                </span>
                              )}
                            </div>
                          ) : field?.type === "date" ? (
                            <DatePicker
                              allowClear
                              className={styles.fieldDatePicker}
                              format={"MM/DD/YYYY"}
                            />
                          ) : field?.type === "dropdown" ? (
                            <Select
                              allowClear
                              placeholder={field?.label}
                              options={field?.dropdowns
                                ?.filter((r) =>
                                  r?.regions?.find((r) => r === coverageCountry),
                                )?.[0]
                                ?.values?.map((opt) => {
                                  return { label: opt?.name, value: opt?.value };
                                })}
                              className={styles.fieldSelect}
                              value={field?.value}
                            />
                          ) : field?.type === "radio" ? (
                            <>
                              <Radio.Group
                                onChange={(e) =>
                                  checkMedicalQues(
                                    e.target.value,
                                    field?.field_name,
                                  )
                                }
                                options={
                                  field?.values
                                    ? field?.values?.map((field) => {
                                        return {
                                          label: field?.name,
                                          value: field?.value,
                                          style: radioStyle,
                                        };
                                      })
                                    : []
                                }
                              />
                              {commentBoxes?.[field?.field_name] && (
                                <Input.TextArea
                                  placeholder="Please specify"
                                  className={styles.textArea}
                                />
                              )}
                            </>
                          ) : (
                            ""
                          )}
                        </Form.Item>

                        {sortedFields[index]?.type && <div className={styles.sectionDivider} />}
                      </React.Fragment>
                    );
                  }
                })}
          </div>
        </div>
      </Form>

      <div className={styles.actions}>
        <Button
          className={styles.backBtn}
          onClick={() => setCurrent((prev) => prev - 1)}
        >
          <ArrowLeft size={16} />
          Back
        </Button>
        <Button
          type="primary"
          className={styles.continueBtn}
          onClick={onFinish}
          loading={emailCheckStatus === "loading"}
        >
          Continue
          <ArrowRight size={16} />
        </Button>
      </div>
    </div>
  );
}

export default Step2;
